import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';

type LessonTab = 'content' | 'assignment';

interface LessonTabsProps {
  active: LessonTab;
  onChange: (_tab: LessonTab) => void;
}

export const LessonTabs: React.FC<LessonTabsProps> = ({
  active,
  onChange,
}) => {
  return (
    <Box sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={active}
        onChange={(_event, value: LessonTab) => onChange(value)}
      >
        <Tab label="Контент" value="content" />
        <Tab label="Задание" value="assignment" />
      </Tabs>
    </Box>
  );
};

export default LessonTabs;
